import { loadStripe } from "@stripe/stripe-js";
import Axios from "axios";
import Cookies from 'js-cookie';
import { history, MyMess,store } from "../App";
import { GlobalSnackBarUtil } from "../component/GlobalSnackBar";
import { loggoutSuccess } from "../redux/ducks/userDuck";

let prefix = ''

if ( process.env.NODE_ENV === 'development'){
    prefix = 'http://127.0.0.1:3005';
}
export const GetConfig = prefix + "/app/config";
export const CheckAliveUser = prefix + '/app/user/checkAlive';
export const LoginUser = prefix + '/app/user/login';
export const LogoutUser = prefix + '/app/user/logout';
export const UpdateUserPassword = prefix + '/app/user/password';
export const CreatLicense = prefix + '/app/license';
export const EditLicense = prefix + '/app/license';
export const GetLicenses = prefix + '/app/license';
export const GetLicensesStat = prefix + '/app/license/stat';
export const ReadLicense = prefix + '/app/license/load';
export const CheckLicenseAmt = prefix + '/app/license/checkAmt';
export const AddLicensePayment = prefix + '/app/license/checkoutPay';
export const ExtendLicense = prefix + '/app/license/extend';
export const NnlM18 = prefix + '/app/license/nnlm18';
export const IsReachable = prefix + '/app/license/isReachable';
export const ReBranch = prefix + '/app/license/rebranch';

export const GetMerchants = prefix + '/app/merchant/list';
export const CreateMerchant = prefix + '/app/merchant';
export const EditMerchant = prefix + '/app/merchant';
export const ReadMerchant = prefix + '/app/merchant/load';

export const SignUpUser = prefix + '/app/user';
export const ResetPassword = prefix + '/app/user/resetPassword';
export const CheckResetToken = prefix + '/app/user/checkResetPassword';
export const SecreteUpdatePassword = prefix + '/app/user/secreteUpdatePassword';
export const CheckUrl = prefix + '/app/user/checkUrl';
export const ResendVerify = prefix + '/app/user/resendVerify'
export const VerifyUser = prefix + '/app/user/verify'

// domains related

export const GetDomains = prefix + '/app/domains';
export const QuoteDomain = prefix + '/app/domains/search';
export const PurchaseDomain = prefix + '/app/domains/purchase';
export const MapDomain = prefix + '/app/domains/map';
export const RenewDomain = prefix + '/app/domains/renew';

// payments
export const QueryPayment = prefix + '/app/payment/query';
export const QuerySubscriptionPayment = prefix + '/app/payment/subscription/query';


// wallet related
export const GetWallet = `${prefix}/app/wallet`;
export const EnableWallet = `${prefix}/app/wallet/enable`;
export const DepositWallet = `${prefix}/app/wallet/deposit`;
export const QueryTransactions = `${prefix}/app/wallet/transactions`;
export const GetStatistic = `${prefix}/app/wallet/statistic`;
export const QueryStatement = `${prefix}/app/wallet/statement`;

// const addAuthorizationInterceptors = (config) => {
//     const auth = Cookies.get('authorization')
//     console.log('enter interceptors?')
//     if(auth){
//         config.headers.authorization = 'Bearer ' + auth;
//     }
//     config.withCredentials = true;
//     config.allowOrigin = 
//     console.log(config);
//     return config;
// }

export const buildQueryString = function(parameters) {
    const keys = Object.keys(parameters);
    if (keys.length === 0) {
        return '';
    }

    let query = '?';
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        query += key + '=' + encodeURIComponent(parameters[key]);

        if (i < keys.length - 1) {
            query += '&';
        }
    }

    return query;
}

export const loadStripeService = async function(stripeObj){
    return await loadStripe(stripeObj.publicKey, {stripeAccount: stripeObj.acctId } );
}


export const getDirectLoginNnlUrl = async function(code){
  try{
  let res = await Axios.post(NnlM18,{code:code}) 

  if(res && res.status === 200 && res.data && res.data.nnlKey){
    return res.data    
    
  }else{
    GlobalSnackBarUtil.open({
      message:MyMess.kopaproLicense.accessFail,
      severity:'error'
    })
  }
  }catch(e){
    console.log(e);
    GlobalSnackBarUtil.open({
      message:MyMess.kopaproLicense.accessFail,
      severity:'error'
    })
    return {data:{
      error:"Unknown Error"
    }}
  }
}

export const openDirectLogin = async function(code,onOpenHandler){
  let nnlInfo = await getDirectLoginNnlUrl(code);
  if(nnlInfo && nnlInfo.nnlKey && nnlInfo.m18proxy){
    let baseUrl = nnlInfo.m18proxy + "";
    if(!baseUrl.endsWith('/')){
      baseUrl += '/';
    }
    let url = baseUrl + 'jsf/login.faces?nnlKey=' + nnlInfo.nnlKey + '&username=' + code + '&com.multiable.web.viewscope.clear=true';
    //et url = 'http://jk1207-admin.my.kopapro-trial.com/' + 'jsf/login.faces?nnlKey=' + nnlInfo.nnlKey + '&username=' + code;


    await safeOpen(url,code,onOpenHandler)
  }  
}


export const safeOpen= async (url,code,onOpenHandler) => {
  let retry = true;
  let cntMax = 10;
  let cnt = 0;
  let opened = false;
  
    // try{
    //   let res = await isReachable(url);      
    //   if(res){      
    //     window.open(url);
    //     retry = false;
    //   }   
    // } catch(e){
    //   console.log(e)
    // }
  // while(retry){
  //   await delay(500);
  //   try{
  //     let res = await Axios.get(IsReachable + '?code='+ code)
  //     // let res = await Axios.get(url,{
  //     //   headers:{
  //     //     "Access-Control-Allow-Origin": "*"
  //     //   }
  //     // })
  //     console.log(res);
  //     if(res.status == 200){
  //         window.open(url);
  //         retry = false;
  //         opened = true;
  //         break;
  //     }

  //   }catch(e){
      
  //   }
  //   cnt++
  //   if(cnt > cntMax){
  //     retry = false;
  //     break;
  //   }
  // }
  // if(onOpenHandler)
  // onOpenHandler(opened,url);

  // if(cnt > cntMax && !opened){
  //   //open it any way 
  //   window.open(url);
  // }

  //debug local
  await delay(500);
  window.open(url);

 

  // while(retry){
  //   await delay(500);
  //   // try{
  //   //   let res = await isReachable(url);      
  //   //   if(res){      
  //   //     window.open(url);
  //   //     retry = false;
  //   //   }   
  //   // } catch(e){
  //   //   console.log(e)
  //   // }

  //   window.open(url);

  //   cnt++;
  //   if(cnt > cntMax){
  //     retry = false;
  //     GlobalSnackBarUtil.open({
  //       message:"Failed to open URL:" + url
  //     })
  //   }
  // }
  
  return retry;
}

const delay = ms => new Promise(res => setTimeout(res, ms));

Axios.interceptors.request.use( (config) => {
    const auth = Cookies.get('authorization')    
    if(auth){
        config.headers.authorization =auth;
    }
    // config.withCredentials = true;
    // config.allowOrigin = "*";    
    
    return config;
})



// Axios.interceptors.request.use (config => {
//     console.log(config);
// })

Axios.interceptors.response.use(function (res) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return res;
  }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    //console.log(error);
    if(error.response && error.response.status && error.response.status === 403){
        console.log('facing forbidden error, check session ');
        Axios.post(CheckAliveUser).then((isAliveRes) => {
            if(isAliveRes && isAliveRes.status === 200 && isAliveRes.data && isAliveRes.data.alive){
            }else{
                store.dispatch(loggoutSuccess());
                // history.push('/login');
                // GlobalSnackBarUtil.open({
                //     message:MyMess.sessionExpired
                // });
            }
        });
        
    }

    return Promise.reject(error);
  });

  export function parseStdResponseError(data,retLocators){
    
    let pass = false;
    let errorMsg = '';
    let locators = [];
    if(data.classKey){
     if(data.classKey === 'KppResponse'){
       pass = data.pass;
       if(!pass && data.error){        
         let dataError = data.error;
         if(dataError.messCode){
           errorMsg = "KppResponse." + dataError.messCode;
         }

         if(dataError.locators && Array.isArray(dataError.locators)){
          for(let i = 0 ; i < dataError.locators.length ; i++){
            locators.push(dataError.locators[i]);            
          }          
         }
       }
     }else if(data.classKey === 'KppEntityError'){
      errorMsg = "KppResponse." + data.messCode;
     }
   }
 
   
   if(!pass && MyMess.getString(errorMsg)){
     GlobalSnackBarUtil.open({
       message:MyMess.getString(errorMsg),
       severity:'error'
     })    

   }

   if(retLocators && retLocators.push){
    locators.forEach((v,i) =>  retLocators.push(v));   
   }
   return errorMsg;
  }
